import { render, staticRenderFns } from "./AddCoordinator.vue?vue&type=template&id=22756082"
import script from "./AddCoordinator.vue?vue&type=script&lang=js"
export * from "./AddCoordinator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports